import { z } from 'zod';
export const CustomerUserRoleSchema = z.enum(['owner', 'member']);
/** 고객사 사용자 공개 표현. */
export const CustomerUserSchema = z.object({
    id: z.string().uuid(),
    customerId: z.string().uuid(),
    customerName: z.string().optional(),
    email: z.string().email(),
    displayName: z.string(),
    role: CustomerUserRoleSchema,
    lastLoginAt: z.string().datetime().nullable(),
    disabledAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
});
export const CustomerLoginRequestSchema = z.object({
    email: z.string().email(),
    password: z.string().min(1),
});
export const CreateCustomerUserRequestSchema = z.object({
    customerId: z.string().uuid(),
    email: z.string().email(),
    displayName: z.string().min(1).max(200),
    role: CustomerUserRoleSchema.default('member'),
});
export const UpdateCustomerUserRequestSchema = z.object({
    displayName: z.string().min(1).max(200).optional(),
    role: CustomerUserRoleSchema.optional(),
    /** true=disable, false=enable */
    disabled: z.boolean().optional(),
});
//# sourceMappingURL=customer-user.js.map